/* Carga de archivo:   elemento que carga un archivo a la vez */

//*react- recursos

//*componentes-utiles
import GeneraDropzoneUnArchivo from "../../../componentes/generaDropZone/GeneraDropzoneUnArchivo";

//*clases
import "../../../componentes/generaDropZone/dropzone.css";
import { Col, Row } from "react-bootstrap";
import { Button } from "@reactjscomponentrepository/frontend-components/lib/components";

//*datos

//*archivos (imagenes y elementos necesarios para la rutina)

//*api's (servicios y store)

//*store's
import filesStore from "../../../stores/filesStore";

//*componente
export default function Ejemplo() {
  //*api store

  //*store's
  const { filesDropzone } = filesStore((state: any) => ({
    filesDropzone: state.filesDropzone,
  }));

  //*data

  //*constantes y variables
  const myLabels = [{ id: 0, desc: "Cargar archivos" }];

  //*usestate

  //*useEffect

  //*funciones
  const filesUpload = () => {
    const formData = new FormData();
    filesDropzone.map((e: any) => {
      formData.append("files", e.file[0], e.file[0].name);
    });
    console.log("formData UnArchivo****", formData.getAll("files"));
  };

  //*vista
  return (
    <div  className="container container-Vista" >
      <h1>Ejemplo de Dropzone:</h1>
      <Row>
        <Col sm={12} className="align-2">
          <span>
            <Button
              typeStyle="secondary"
              onClick={filesUpload}
              className="margin-3 margin-1"
            >
              <span>{myLabels[0].desc}</span>
            </Button>
          </span>
        </Col>
      </Row>
      <div className="container-Componente" >
          Archivo1 :
          <GeneraDropzoneUnArchivo posi={0} /> <br />
          Archivo2 :
          <GeneraDropzoneUnArchivo posi={1} /> <br />
     
          <div className="divDropE">
            <span>Archivo3 xxxx:</span>
            <br />
            <div className="divDropG">
              <GeneraDropzoneUnArchivo posi={2} />
            </div>
          </div>
          <br />
      </div>
      <br />
    </div>
  );
}
